var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"5rem"}},[_c('h5',{staticClass:"mb-5"},[_vm._v("เกี่ยวกับเรา")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.home.about)}})])}
var staticRenderFns = []

export { render, staticRenderFns }